/* eslint-disable no-bitwise, no-restricted-properties */
var SI_POSTFIXES = ['', 'k', 'M', 'B'];
export default (function (number) {
  // what tier? (determines SI prefix)
  var tier = Math.log(Math.abs(number)) * Math.LOG10E / 3 | 0; // if zero, we don't need a prefix

  if (tier === 0) return "".concat(number); // get postfix and determine scale

  var postfix = SI_POSTFIXES[tier];
  var scale = Math.pow(10, tier * 3); // scale the number

  var scaled = number / scale; // format number and add postfix as suffix

  return "".concat(scaled.toFixed(1)).concat(postfix);
});